import { render, staticRenderFns } from "./LeaveReview.vue?vue&type=template&id=928a21e0&"
import script from "./LeaveReview.vue?vue&type=script&lang=ts&"
export * from "./LeaveReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LeaveReview.vue"
export default component.exports